import * as React from 'react';
import { useParams } from 'react-router-dom';

import { PK } from 'common/types';
import { TITLE_VARIANTS } from 'common/consts';
import { DetailsCard, DetailsSuspense } from 'templates/details';

import MinisPicker from '../components/MinisPicker';
import SeriesPicker from '../components/SeriesPicker';
import { useCollectionDetails } from '../queries';
import { Section, SectionsWrapper } from '../../../templates/core';
import { Title } from '../../../common/components';
import { COLLECTION_ITEM_TYPES } from '../consts';

const CollectionDetails = () => {
  const { pk } = useParams<{ pk?: PK }>();
  const { data, ...query } = useCollectionDetails(pk);

  return (
    <DetailsCard created={data?.created_at} lastUpdate={data?.modified_at}>
      <DetailsSuspense isLoading={query.isLoading} error={query.error}>
        <Section>
          <Title variant={TITLE_VARIANTS.HEADER}>{data?.title || ''}</Title>
        </Section>
        <SectionsWrapper pk={data?.pk} collectionItems={data?.items}>
          {data?.item_type === COLLECTION_ITEM_TYPES.SERIES ? (
            <SeriesPicker />
          ) : (
            <MinisPicker />
          )}
        </SectionsWrapper>
      </DetailsSuspense>
    </DetailsCard>
  );
};

export default CollectionDetails;
